import { app } from "@/main.js";

export function isSafariMobile() {
  const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/); //eslint-disable-line
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const iPadOS =
    /Macintosh/.test(navigator.userAgent) &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2;
  if (isSafari && (iOS || iPadOS)) {
    return true;
  }
  return false;
}

export async function copyToClipboard(value) {
  try {
    await navigator.clipboard.writeText(value);
    this.$root.showSuccess(
      "<strong>in Zwischenablage kopiert:</strong><br>" + value
    );
  } catch (err) {
    this.$root.showError("Fehler beim Kopieren in die Zwischenablage");
  }
}

export async function getEmailClient() {
  let emailClient = localStorage.getItem("emailClient");
  if (emailClient) {
    return emailClient;
  }
  emailClient = (
    await app.apiList({
      resource: "app/settings",
      query: "key=emailClient",
    })
  ).value;
  if (emailClient) {
    localStorage.setItem("emailClient", emailClient);
    return emailClient;
  }
  return "mailto";
}

export function setEmailClient(emailClient) {
  localStorage.setItem("emailClient", emailClient);
  app.apiPost({
    resource: "app/settings",
    data: { key: "emailClient", value: emailClient },
  });
}

export async function getEmailDivider() {
  let emailDivider = localStorage.getItem("emailDivider");
  if (emailDivider) {
    return emailDivider;
  }
  emailDivider = (
    await app.apiList({
      resource: "app/settings",
      query: "key=emailDivider",
    })
  ).value;
  if (emailDivider) {
    localStorage.setItem("emailDivider", emailDivider);
    return emailDivider;
  }
  return "comma";
}

export function setEmailDivider(emailDivider) {
  localStorage.setItem("emailDivider", emailDivider);
  app.apiPost({
    resource: "app/settings",
    data: { key: "emailDivider", value: emailDivider },
  });
}

export function joinEmails(emails) {
  if (!emails || emails.length == 0) {
    return "";
  }
  const emailDivider = localStorage.getItem("emailDivider") || "comma";
  const divider = emailDivider == "semicolon" ? "; " : ", ";
  return emails.join(divider);
}

export async function mailto(value) {
  if ((await getEmailClient()) == "outlook") {
    return "https://outlook.office365.com/mail/deeplink/compose?to=" + value;
  }
  return "mailto:" + value;
}

export function sortLookups(lookups) {
  if (!lookups) {
    return lookups;
  }
  return lookups.slice().sort((a, b) => {
    return compareLookups(a, b);
  });
}

export function compareLookups(a, b) {
  if (!a) {
    return 1;
  }
  if (!b) {
    return -1;
  }
  return a.code.localeCompare(b.code, "de-CH");
}

export function searchLookup(lookup, search) {
  if (!search) {
    return false;
  }
  if (!lookup) {
    return false;
  }
  const s = search.toLowerCase();
  const code = lookup.code.toLowerCase();
  const description = lookup.description.toLowerCase();
  return code.includes(s) || description.includes(s);
}
